module.exports = __webpack_public_path__ + "static/media/folder.40d7ee67.svg";